import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Grid, Button } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import {  useDispatch  } from 'react-redux';
import { sendForgottenPassword } from '../actions/password.actions';

const ForgottenPassword = props => {
  const [ userName, setUserName ] = useState('');
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleOnChangeUserName = event => setUserName(event.target.value);

  const handleSend = () =>
    dispatch(sendForgottenPassword({ userName }, props.history));

  const handleBack = () =>
    props.history.push('/');

  const useStyles = makeStyles({
    root: {
      justify: 'center',
      minHeight: '100vh'
    },
    paper: {
      padding: '20px',
      width: '250px'
    },
    textField: {
      width: '100%',
      marginTop: '10px',
      marginBottom: '10px'
    },
    helpText: {
      marginTop: '20px'
    },
    buttonBox: {
      display: 'flex',
      direction: 'row',
      justifyContent: 'space-between',
      marginTop: '20px'
    }
  });

  const classes = useStyles();

  return (
    <Grid container className={ classes.root } justifyContent="center" alignItems="center">
      <Paper className={ classes.paper }>
        <Grid container direction={ 'column' }>
          <Typography variant="h5" component="h3">
            { t('forgotten_password.title') }
          </Typography>
          <Typography className={ classes.helpText } component="h6">
            { t('forgotten_password.description') }
          </Typography>
          <TextField
            label={ t('forgotten_password.label.user_name') }
            className={ classes.textField }
            onChange={ handleOnChangeUserName }
          />
        </Grid>
        <Grid
          container
          className={ classes.buttonBox }>
          <Button
            onClick={ handleBack }
            className={ classes.backBtn }
            color="primary"
          >
            { t('forgotten_password.button.back') }
          </Button>
          <Button onClick={ handleSend }
            color="primary"
            variant="outlined"
          >
            { t('forgotten_password.button.send') }
          </Button>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default ForgottenPassword;
